import { useEffect } from "react";
import { useRegisterSW } from "virtual:pwa-register/react";
import { toast } from "sonner";
import { captureException } from "@/lib/sentry";

export function useUpdatePrompt() {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisterError(error) {
      captureException(
        error instanceof Error ? error : new Error(String(error)),
        { extra: { context: "sw.register" } },
      );
    },
  });

  useEffect(() => {
    if (!needRefresh) return;

    // On mobile, users rarely interact with toasts. When the app is
    // backgrounded and reopened, silently reload to apply the new version.
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        updateServiceWorker(true);
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);

    toast.info("¡Nueva versión disponible!", {
      description: "Toca Actualizar para ver los últimos cambios.",
      action: {
        label: "Actualizar",
        onClick: () => updateServiceWorker(true),
      },
      duration: Infinity,
      id: "pwa-update",
    });

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [needRefresh, updateServiceWorker]);
}
